// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as Css_Js_Core from "bs-css/src/Css_Js_Core.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";

var wrapper = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.display("flex"),
      BsCssJs$PrezzeeRibbon.flexDirection("column"),
      BsCssJs$PrezzeeRibbon.boxShadow(Css_Js_Core.Shadow.box(BsCssJs$PrezzeeRibbon.px(0), BsCssJs$PrezzeeRibbon.px(2), BsCssJs$PrezzeeRibbon.px(5), undefined, undefined, BsCssJs$PrezzeeRibbon.rgba(0, 0, 0, {
                    NAME: "percent",
                    VAL: 7.0
                  }))),
      BsCssJs$PrezzeeRibbon.borderRadius(BsCssJs$PrezzeeRibbon.px(8))
    ]);

var Styles = {
  wrapper: wrapper
};

function ContentCard(props) {
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: Classnames([
                    wrapper,
                    className$1
                  ])
            });
}

var make = ContentCard;

export {
  Styles ,
  make ,
}
/* wrapper Not a pure module */
